export const B2B_FUNDING_TYPE = {
  COMPANY_FUNDED: 'COMPANY_FUNDED',
  SELF_FUNDED: 'SELF_FUNDED',
}

/**
 * Query param the B2B log-in page reads to decide how it recovers a session. With `status=403`
 * it re-verifies the token's `storeProgramIds` claim and signs the visitor out on a mismatch;
 * without it an Amplify session that still holds a token is pushed straight back to the
 * collection page, so a server-side "token refused" redirect must always carry it.
 */
// eslint-disable-next-line i18next/no-literal-string -- query-param name, not user-facing copy
export const B2B_LOGIN_STATUS_PARAM = 'status'
export const B2B_LOGIN_STATUS_FORBIDDEN = '403'

export const B2B_LOGIN_FAILED_REASONS = {
  NON_WHITELISTED_EMAIL: 'non_whitelisted_email',
  INVALID_OTP: 'invalid_otp',
  EXPIRED_OTP: 'expired_otp',
}

export const B2B_EVENT_ENTITY_TYPE = {
  // eslint-disable-next-line i18next/no-literal-string
  B2B_LOGIN_SUCCESS: 'b2b_login_success',
  // eslint-disable-next-line i18next/no-literal-string
  B2B_LOGIN_FAILED: 'b2b_login_failure',
  // eslint-disable-next-line i18next/no-literal-string
  B2B_LOGIN_EMAIL_SUBMITTED: 'b2b_login_attempt',
  // eslint-disable-next-line i18next/no-literal-string
  B2B_LOGIN_OTP_SUBMITTED: 'b2b_login_otp',
  // eslint-disable-next-line i18next/no-literal-string
  B2B_PAGE_VIEW: 'b2b_login_page',
}
